import type { MenuItemConfigData } from '../../../types';

interface GetHiddenItemsResult {
	hiddenAppItemsData: MenuItemConfigData[];
	hiddenProductItemsData: MenuItemConfigData[];
	shouldShowMoreMenu: boolean;
}

export function getHiddenItems(
	productItemsData: MenuItemConfigData[],
	appItemsData: MenuItemConfigData[],
	peekingMenuIds: string[],
): GetHiddenItemsResult {
	const checkIsHiddenMenuItem = ({ menuId, visible }: MenuItemConfigData) =>
		!visible && !peekingMenuIds.includes(menuId);

	const hiddenProductItemsData = productItemsData.filter(checkIsHiddenMenuItem);
	const hiddenAppItemsData = appItemsData.filter(checkIsHiddenMenuItem);

	return {
		hiddenProductItemsData,
		hiddenAppItemsData,
		shouldShowMoreMenu: hiddenProductItemsData.length !== 0 || hiddenAppItemsData.length !== 0,
	};
}
